import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private timers: number[] = []; // Array to track all timers

  constructor() {
    this.overrideSetTimeout();
  }

  // Override global setTimeout
  private overrideSetTimeout() {
    const originalSetTimeout = window.setTimeout;

    // Override the global setTimeout
    window.setTimeout = ((callback: (...args: any[]) => void, delay?: number, ...args: any[]) => {
      const timerId = originalSetTimeout(callback, delay, ...args);
      this.timers.push(timerId); // Track the timer
      return timerId;
    }) as typeof setTimeout;
  }

  // Method to clear all tracked timers
  clearAllTimers() {
    this.timers.forEach(timerId => clearTimeout(timerId)); // Clear each timer
    this.timers = []; // Reset the array
   // console.log(this.timers + 'All timers cleared.');
  }

  // Method to check if timers are still running
  hasActiveTimers(): boolean {
    return this.timers.length > 0;
  }
}
